function Footer() {     
  return (  
    <footer style={styles.footer}>
      <p>© 2026 AgriConnect. All rights reserved.</p>
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: "40px",
    padding: "10px",
    textAlign: "center",
    borderTop: "1px solid #ddd",
    color: "#666",
  },
};

export default Footer;
